module.exports = __webpack_public_path__ + "static/media/fr_3l.917b800f.png";